/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import PRSList from "./PRSList";
import { Tabs } from "antd";

import constants from "../../constants/constants";

const InnerTabs = ({ dpType }) => {
  const [activeKey, setActiveKey] = useState("1");
  const [tabValue, setTabValue] = useState("unassigned");
  const onChange = (key) => {
    setActiveKey(key);
    setTabValue(key === "1" ? "unassigned" : "all");
  };

  return (
    <Tabs
      defaultActiveKey="1"
      activeKey={activeKey}
      onChange={onChange}
      items={[
        {
          label: "Unassigned",
          key: "1",
          children: <PRSList tabValue={tabValue} dpType={dpType} />,
        },
        {
          label: "All",
          key: "2",
          children: <PRSList tabValue={tabValue} dpType={dpType} />,
        },
      ]}
    />
  );
};

const PRS = () => {
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const isHOAdmin = userinfo?.roles?.includes(constants.ROLES.HO_ADMIN);

  const [activeKey, setActiveKey] = useState("1");
  const [tabValue, setTabValue] = useState("unassigned");
  const onChange = (key) => {
    setActiveKey(key);
    setTabValue(key === "1" ? "unassigned" : "all");
  };

  return (
    <div className="p-1">
      <Heading title="PRS" />
      <div className="global-card-tab-container">
        {isHOAdmin ? (
          <Tabs
            items={[
              {
                label: "ECOMM",
                key: "1",
                children: <InnerTabs dpType="ECOMM" />,
              },
              {
                label: "Web Booking",
                key: "2",
                children: <InnerTabs dpType="COURIER" />,
              },
            ]}
          />
        ) : (
          <Tabs
            defaultActiveKey="1"
            activeKey={activeKey}
            onChange={onChange}
            items={[
              {
                label: "Unassigned",
                key: "1",
                children: <PRSList tabValue={tabValue} />,
              },
              {
                label: "All",
                key: "2",
                children: <PRSList tabValue={tabValue} />,
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default PRS;
